import React from 'react';
import { RichEditorControl } from '../CommonProperties';
import { usePropertyPanel } from '../PropertyPanelContext';

const RichEditorProperties = () => {
  const { devicePropertyTab } = usePropertyPanel();

  return (
    <div className="property-group">
        <RichEditorControl />
    </div>
  );
};

export default RichEditorProperties;
